module.exports = __webpack_public_path__ + "static/images/play.b79c697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/play.png
// module id = MNRI
// module chunks = 6 7